module.exports = __webpack_public_path__ + "img/lapresse.c0254a85.png";